import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { MutationFunction } from "@tanstack/react-query";
import type { PlanModel } from "@/features/subscriptions/api/models/PlanModel";

export const usePlanForPromoCode = () => {
	const http = useHTTP("Required");

	const mutationFn: MutationFunction<HTTPResponse<PlanModel>, string> = promoCode => {
		return http<PlanModel>({
			method: "GET",
			url: `/plan/${encodeURIComponent(promoCode)}`
		});
	};

	return useHTTPMutation({
		mutationFn
	});
};
